import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import FilterSelect from "component/common/FilterSelect";
import { getRevenue } from "service/Dashboard";
import { Toast } from "utils/toast";
import ChartLoader from "component/common/ChartLoader";

import styles from "./RevenueEarned.module.scss";
import { useHistory } from "react-router-dom";

const RevenueEarned = () => {
  let [revenue, setRevenue] = useState({
    series: [
      {
        name: "Revenue",
        data: [],
      },
    ],
    options: {
      chart: {
        type: "line",
        redrawOnWindowResize: true,
        redrawOnParentResize: true,
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
      },
      colors: ["#3C5877"],
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
      },
      grid: {
        row: {
          colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
          opacity: 0.5,
        },
      },
      markers: {
        size: 5,
        colors: ["#3C5877"],
        strokeColors: "#fff",
        strokeWidth: 2,
        hover: {
          size: 7,
        },
      },
      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
      },
      yaxis: {
        labels: {
          formatter: function (value) {
            if (value >= 10000000) {
              value = value / 10000000 + "Cr";
            } else if (value >= 100000) {
              value = value / 100000 + "L";
            } else if (value >= 1000) {
              value = value / 1000 + "K";
            }
            return `₹${value}`;
          },
        },
      },
      tooltip: {
        x: {
          show: false,
        },
        y: {
          formatter: function (value) {
            return Number(value).toLocaleString("en-IN", {
              maximumFractionDigits: 2,
              style: "currency",
              currency: "INR",
            });
          },
        },
      },
    },
  });

  let [loading, setLoading] = useState(true);

  let [year, setYear] = useState(2021);

  const yearOptions = [2021];

  useEffect(() => {
    setLoading(true);
    getRevenueDetails();
  }, [year]);

  const getRevenueDetails = async () => {
    try {
      let response = await getRevenue({ year: year });
      if (response.status == 200) {
        let revenueData = Array(new Date().getMonth() + 1)
          .fill(0)
          .concat(Array(12 - (new Date().getMonth() + 1)).fill(null));
        response.data.data.map((list) => {
          revenueData[list._id - 1] = list.Revenue;
        });
        let revenueChart = revenue;
        revenueChart.series[0].data = revenueData;
        setRevenue(revenueChart);
        setLoading(false);
      }
    } catch (error) {
      Toast({ type: "error", message: error.data.message });
    }
  };

  const history = useHistory()
  return (
    <div className="col-md-6">
      <div className={styles.revenue_chart}>
        <div className={styles.revenue_chart_title}>
          <b>Revenue Earned</b>
          <div style={{ width: "100px" }}>
            <FilterSelect
              options={yearOptions}
              value={year}
              onChange={(e) => setYear(e.value)}
            />
          </div>
        </div>
        {loading ? (
          <ChartLoader />
        ) : (
          <ReactApexChart
            options={revenue.options}
            series={revenue.series}
            type="line"
            height={300}
          />
        )}
      </div>
    </div>
  );
};

export default RevenueEarned;
